/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Button, Divider, Form, Input, Modal} from "antd";
import TextArea from "antd/es/input/TextArea";

interface WriteNoticePopupProps {
	showPopup: boolean;
	onCancel: () => any;
	onSubmit: (title: string, content: string) => any;
}

const WriteNoticePopup = ({
	                        showPopup,
	                        onCancel,
	                        onSubmit,
                        }: WriteNoticePopupProps) => {
	const [isButtonDisabled, setIsButtonDisabled] = useState(true);

	const [form] = Form.useForm();
	const formItemLayout = {
		labelCol: {
			xs: {span: 24},
			sm: {span: 4},  // 레이블의 폭 조정 (기본 8을 줄여봄)
		},
		wrapperCol: {
			xs: {span: 24},
			sm: {span: 18},  // 입력 필드의 폭 조정
		},
	};

	const handleValuesChange = (changedValues: any, allValues: any) => {
		const {title, content} = allValues;
		setIsButtonDisabled(!title || !content);
	};

	return (
		<Modal
			title={<span style={{color: '#1677ff', fontSize: '1em'}}>공지사항 작성</span>}
			open={showPopup}
			onCancel={onCancel}
			footer={null}
			width={500}
			styles={{body: {paddingBottom: 0}}}
		>
			<Divider/>
			<Form
				{...formItemLayout}
				form={form}
				variant={'outlined'}
				size={'large'}
				onFinish={({ title, content }) => onSubmit(title, content)}
				onValuesChange={handleValuesChange}
				style={{width: '100%', marginTop: '20px'}}
			>
				<Form.Item
					label="제목"
					name="title"
					rules={[{required: true, message: '제목을 입력하세요.'}]}
				>
					<Input/>
				</Form.Item>
				<Form.Item
					label="내용"
					name="content"
					rules={[{required: true, message: '내용을 입력하세요.'}]}
				>
					<TextArea rows={4}/>
				</Form.Item>

				<Form.Item style={{display: 'flex', justifyContent: 'flex-end', marginRight: '50px'}} label={null}>
					<Button
						type="primary"
						size="middle"
						htmlType="submit"
						disabled={isButtonDisabled}
					>
						작성
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default WriteNoticePopup;
